export default __webpack_public_path__ + "static/media/417.65947d77.gif";